module.exports = __webpack_public_path__ + "static/media/workingmemory-words-1.625dd5d3.mp3";